import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { DialogComponent } from './dialog.component';


@NgModule({
  declarations: [
    DialogComponent
  ],
  imports: [
    BrowserModule,
    
  ],
 
  bootstrap: [DialogComponent]
})
export class DialogModule { }
